export const LI_SMOKE = "li_smoke";
export const PAYOUT_MODE = "payout-mode";
export const PLAN_OPTION = "plan-option";
export const PR_PT = "pt";
export const PR_PPT = "ppt";
export const INPUT_MODE = "payment-frequency"
export const SumAssuredpayoutoption = "payment-option"
export const PR_SA = "PR_SA"
export const PR_ANNPREM = "PR_ANNPREM"